import { PureComponent } from "react";

export default class SmartEcoSystemFeatures extends PureComponent {
    render() {
        return (
            <>
                <div className="swap-textBox">
                    <div className="container-Grid">
                        <div
                            className="swap-boxWrap wow fadeInUp"
                            data-wow-delay="0.3s"
                        >
                            <div className="swap-Box01">
                                <div className="icon-Box icon04">
                                    <svg>
                                        <g>
                                            <path className="cst0" d="M31.7,19.4l-1-1c-1.3-1.3-3-2.3-4.7-2.8L22.5,19c2-0.1,3.9,0.6,5.4,2.1l1,1c2.8,2.8,2.8,7.3,0,10.1L17,44.1
                                    c-2.8,2.8-7.3,2.8-10.1,0l-1-1c-2.8-2.8-2.8-7.3,0-10.1l7.5-7.5c-0.3-1.4-0.5-3.3-0.1-5.3L3.2,30.2c-4.3,4.3-4.3,11.3,0,15.6l1,1
                                    c4.3,4.3,11.3,4.3,15.6,0L31.7,35C36,30.7,36,23.7,31.7,19.4"/>
                                            <path className="cst1" d="M27.3,31.1c-1.9,0-3.8-0.7-5.2-2.1l-1-1c-2.8-2.8-2.8-7.3,0-10.1L32.9,5.9c2.8-2.8,7.3-2.8,10.1,0l1,1
                                    c2.8,2.8,2.8,7.3,0,10.1l-7,7c0.3,1.4,0.4,3.3-0.1,5.5l9.8-9.8c4.3-4.3,4.3-11.3,0-15.6l-1-1c-4.3-4.3-11.3-4.3-15.6,0L18.3,15.1
                                    c-4.3,4.3-4.3,11.3,0,15.6l1,1c1.3,1.3,2.9,2.2,4.6,2.7L27.3,31.1z"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100% <br /> multichain
                                    </div>
                                    <p> No wraps, no side-chain, no light chain, 100% true one-click swap between all blockchains</p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon01">
                                    <svg>
                                        <g>
                                            <path className="cst0" d="M26.6,48.5c-0.8,0-1.5-0.6-1.5-1.5V1.5c0-0.8,0.6-1.5,1.5-1.5c0.8,0,1.5,0.6,1.5,1.5V47
                                    C28.1,47.8,27.4,48.5,26.6,48.5"/>
                                            <path className="cst1" d="M45.7,48.5H7.5c-0.8,0-1.5-0.6-1.5-1.5c0-0.8,0.6-1.5,1.5-1.5h38.2c0.8,0,1.5,0.6,1.5,1.5
                                    C47.2,47.8,46.5,48.5,45.7,48.5"/>
                                            <path className="cst1" d="M46.2,12.4H7.1c-0.8,0-1.5-0.6-1.5-1.5c0-0.8,0.6-1.5,1.5-1.5h39.2c0.8,0,1.5,0.6,1.5,1.5
                                    C47.7,11.8,47,12.4,46.2,12.4"/>
                                            <path className="cst1" d="M19.9,25.3L19.9,25.3c0-0.3-0.1-0.4-0.2-0.6l-8.5-14.5C11,9.8,10.5,9.5,10,9.5c-0.5,0-1,0.3-1.3,0.7L0.2,24.7
                                    C0.1,24.9,0.1,25,0,25.2v0.1c0,0.1,0,0.1,0,0.2v0c0,3.8,4.4,6.8,10,6.8s10-3,10-6.8v0C19.9,25.4,19.9,25.4,19.9,25.3 M10,13.9
                                    l6,10.2H4L10,13.9z M10,29.4c-3.1,0-5.4-1.1-6.5-2.5h13C15.4,28.3,13,29.4,10,29.4"/>
                                            <path className="cst0" d="M52.9,25.3L52.9,25.3c0-0.3-0.1-0.4-0.2-0.6l-8.5-14.5c-0.3-0.5-0.7-0.7-1.3-0.7c-0.5,0-1,0.3-1.3,0.7
                                    l-8.5,14.5c-0.1,0.2-0.1,0.3-0.2,0.5v0.1c0,0.1,0,0.1,0,0.2v0c0,3.8,4.4,6.8,10,6.8s10-3,10-6.8v0C52.9,25.4,52.9,25.4,52.9,25.3
                                    M42.9,13.9l6,10.2H37L42.9,13.9z M42.9,29.4c-3.1,0-5.4-1.1-6.5-2.5h13C48.4,28.3,46,29.4,42.9,29.4"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100% <br />
                                        value match
                                    </div>
                                    <p>Select the slippage free option to receive new crypto equal to the exact value you sent
                                        <i className="help-circle">
                                            <i
                                                className="fas fa-question-circle protip"
                                                data-pt-position="top"
                                                data-pt-title="The slippage option finds the best price in the market with a slippage limit option under your trade options"
                                                aria-hidden="true"
                                            ></i>
                                        </i>
                                    </p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon02">
                                    <svg>
                                        <g>
                                            <path className="cst1" d="M36.3,16.3h-3.6v-3.9C32.7,5.6,27.1,0,20.3,0S7.9,5.6,7.9,12.4v3.9H5.6c-3.1,0-5.6,2.5-5.6,5.6v20.8
                                    c0,3.1,2.5,5.6,5.6,5.6h30.6c3.1,0,5.6-2.5,5.6-5.6V21.9C41.9,18.8,39.3,16.3,36.3,16.3 M10.8,12.4c0-5.2,4.2-9.5,9.5-9.5
                                    c5.2,0,9.5,4.2,9.5,9.5v3.9H10.8V12.4z M38.8,42.7c0,1.4-1.1,2.6-2.6,2.6H5.6c-1.4,0-2.6-1.1-2.6-2.6V21.9c0-1.4,1.1-2.6,2.6-2.6
                                    h30.6c1.4,0,2.6,1.1,2.6,2.6V42.7z"/>
                                            <path className="cst0" d="M25.9,30c0-2.8-2.3-5-5-5c-2.7,0-5,2.3-5,5c0,2.2,1.5,4.1,3.5,4.7v3.2c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5
                                    v-3.2C24.4,34.1,25.9,32.2,25.9,30 M20.9,31.9c-1,0-1.9-0.9-1.9-1.9c0-1,0.9-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9
                                    C22.8,31.1,21.9,31.9,20.9,31.9"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100%
                                        <br />
                                        safe
                                    </div>
                                    <p>
                                        No hot wallet, no deposits, no accounts, no custodial wallets
                                        <i className="help-circle">
                                            <i
                                                className="fas fa-question-circle protip"
                                                data-pt-position="top"
                                                data-pt-title="All transactions take place on-chain via the blockchains swapping through trustless smart contracts"
                                                aria-hidden="true"
                                            ></i>
                                        </i>
                                    </p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon03">
                                    <svg>
                                        <g>
                                            <path className="cst0" d="M26.5,38.9V42h-2.7v-3c-2.7-0.2-5.4-1-6.9-2.2l1.5-3.4c1.4,1,3.4,1.8,5.4,2v-4.6c-3.1-0.8-6.5-1.8-6.5-5.7
                                  c0-2.9,2.1-5.5,6.5-5.9v-3.1h2.7v3c2.1,0.2,4.1,0.7,5.6,1.7L30.8,24c-1.4-0.8-2.9-1.3-4.2-1.4v4.7C29.6,28,33,29,33,32.9
                                  C33,35.8,30.9,38.3,26.5,38.9 M23.8,26.6v-4c-1.5,0.3-2,1.1-2,2C21.7,25.7,22.5,26.2,23.8,26.6 M28.5,33.3c0-1-0.8-1.5-2-1.9v3.8
                                  C27.9,34.9,28.5,34.2,28.5,33.3"/>
                                            <path className="cst1" d="M26.4,4.1V0.7c0-0.3-0.2-0.6-0.6-0.7c-0.4-0.1-0.8-0.1-1.1,0.1l-6.3,4.9c-0.2,0.2-0.3,0.3-0.3,0.5
                                  c0,0.2,0.1,0.4,0.3,0.5l6.3,4.9c0.3,0.2,0.6,0.3,1.1,0.2s0.6-0.3,0.6-0.7V7.2c10.9,1,19.5,10.1,19.5,21.3
                                  c0,11.8-9.6,21.4-21.4,21.4c-11.8,0-21.4-9.6-21.4-21.4c0-6.3,2.7-11.9,7-15.8L8.7,9.9C3.4,14.4,0,21.1,0,28.5C0,42,11,53,24.5,53
                                  S49,42,49,28.5C49,15.6,39.1,5.1,26.4,4.1"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100%
                                        <br />
                                        reimbursement
                                    </div>
                                    <p>
                                        Fees and gas reimbursed fully with SMART
                                        <i className="help-circle">
                                            <i
                                                className="fas fa-question-circle protip"
                                                data-pt-position="top-right-corner"
                                                data-pt-title="#reimburTip"
                                                data-pt-width="402"
                                                aria-hidden="true"
                                            ></i>
                                        </i>
                                    </p>
                                </div>
                                <div id="reimburTip" style={{ display: "none" }}>
                                    <p style={{ marginTop: '0px' }}>SmartSwap users have the option to receive 100% reimbursement for their gas and swap fees. Users are able to claim reimbursements via the reimbursement staking contract. To release reimbursements users must stake the 1:1 equal amount of SMART for one year, but will be able to release partial amounts of the reimbursement if withdrawn at any time before the 1 year period . The pending balance accumulates and the user is able to claim the rest.</p>
                                    <p style={{ marginBottom: '0px' }}>Example </p>
                                    <p style={{ marginTop: '0px', marginBottom: '0px' }}>If over the year a user spent over $1000 or more on gas, at any time he can be reimbursed for such cost even if the SMART token value is higher due to appreciation. </p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon05">
                                    <svg>
                                        <g>
                                            <path className="cst0" d="M26,35.8v3h-2.7v-3c-2.7-0.2-5.3-1-6.7-2.2l1.5-3.3c1.3,1,3.3,1.7,5.3,1.9v-4.5c-3-0.7-6.4-1.7-6.4-5.6
                                    c0-2.9,2.1-5.3,6.4-5.8v-3H26v2.9c2,0.2,4,0.7,5.5,1.7l-1.3,3.3c-1.4-0.8-2.8-1.2-4.1-1.4v4.6c3,0.7,6.3,1.7,6.3,5.5
                                    C32.3,32.9,30.2,35.3,26,35.8 M23.3,23.8V20c-1.5,0.3-2,1.1-2,2C21.3,23,22.1,23.5,23.3,23.8 M27.9,30.4c0-0.9-0.8-1.5-1.9-1.9v3.7
                                    C27.4,31.9,27.9,31.2,27.9,30.4"/>
                                            <path className="cst1" d="M50.2,0.4c-0.6-0.6-1.6-0.6-2.1,0l-7.7,7.7c-4.3-4-10-6.4-16.3-6.4c-13.2,0-24,10.8-24,24
                                    C0,32,2.5,37.7,6.4,42l-5,5c-0.6,0.6-0.6,1.6,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4l5.1-5.1
                                    c4.1,3.5,9.5,5.6,15.4,5.6c13.2,0,24-10.8,24-24c0-5.8-2.1-11.2-5.6-15.4l7.7-7.7C50.8,2,50.8,1,50.2,0.4 M3,25.7
                                    C3,14.1,12.4,4.8,24,4.8c5.5,0,10.4,2.1,14.1,5.5L8.6,39.9C5.2,36.1,3,31.1,3,25.7 M45,25.7c0,11.5-9.4,21-21,21
                                    c-5,0-9.6-1.8-13.2-4.7l29.4-29.4C43.2,16.1,45,20.7,45,25.7"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100% <br /> free license
                                    </div>
                                    <p>Build your own SmartSwap at no cost or become an affiliate </p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon06">
                                    <svg>
                                        <g>
                                            <path className="cst0" d="M5.8,13.6c0,0,6-3.9,10.1,3.1c0,0,3.3,1.2,2.2-1.8S10.7,9,5.8,13.6" />
                                            <path className="cst0" d="M6.6,19.2c0,0,3.7-3.3,7.5,0C14.1,19.2,10.7,22.1,6.6,19.2" />
                                            <path className="cst0" d="M36,13.6c0,0-6-3.9-10.1,3.1c0,0-3.3,1.2-2.2-1.8C24.9,12,31.1,9,36,13.6" />
                                            <path className="cst0" d="M35.2,19.2c0,0-3.7-3.3-7.5,0C27.6,19.2,31,22.1,35.2,19.2" />
                                            <path className="cst0" d="M27.6,35c-3.8,0-5.5-4-5.5-4H21h-1.1c0,0-1.7,4-5.5,4s-7.2-4.6-7.2-4.6s2.6,6.8,6.9,6.8s6.9-2.4,6.9-2.4
                                    s2.5,2.4,6.9,2.4s6.9-6.8,6.9-6.8S31.4,35,27.6,35"/>
                                            <path className="cst1" d="M41.5,4.8C41.2,4.5,33.8,0,21,0S0.8,4.6,0.5,4.8L0,5.1v25.6l0,0.2c2.6,12.2,19.7,22,20.4,22.4l0.5,0.3l0.5-0.3
                                    c0.7-0.4,17.8-10.2,20.4-22.4L42,5L41.5,4.8z M39.9,30.6C38,39,28.1,46.6,23.2,49.8V42h-4.4v7.9C13.9,46.6,3.9,39.1,2,30.6V6.2
                                    C3.8,5.2,10.5,2,20.9,2c10.5,0,17.1,3.2,18.9,4.2L39.9,30.6L39.9,30.6z"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100% <br /> anonymous
                                    </div>
                                    <p>Complete privacy guard with no KYC / AML needed</p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon07">
                                    <svg>
                                        <g>
                                            <path className="cst0" d="M42.2,37.6H16c-3.1,0-5.7-2.5-5.7-5.7V5.7C10.3,2.5,12.8,0,16,0h26.3c3.1,0,5.7,2.5,5.7,5.7v26.3
                                    C47.9,35.1,45.4,37.6,42.2,37.6 M16,3.1c-1.4,0-2.6,1.1-2.6,2.6v26.3c0,1.4,1.1,2.6,2.6,2.6h26.3c1.4,0,2.6-1.1,2.6-2.6V5.7
                                    c0-1.4-1.1-2.6-2.6-2.6H16z"/>
                                            <path className="cst1" d="M17.7,39.8v3.5c0,1.4-1.1,2.6-2.6,2.6H5.7c-1.4,0-2.6-1.1-2.6-2.6v-9.4c0-1.4,1.1-2.6,2.6-2.6H8v-3.1H5.7
                                    c-3.1,0-5.7,2.5-5.7,5.7v9.4c0,3.1,2.5,5.7,5.7,5.7h9.4c3.1,0,5.7-2.5,5.7-5.7v-3.5H17.7z"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100% <br /> scalable
                                    </div>
                                    <p>No LP, no pools, true decentralized CEX and OTC liquidity bridge</p>
                                </div>
                            </div>
                            <div className="swap-Box01">
                                <div className="icon-Box icon09">
                                    <svg>
                                        <rect x="15.9" y="14.3" transform="matrix(-0.7819 0.6234 -0.6234 -0.7819 43.8185 24.7639)" className="cst0" width="3.4" height="11.6" />
                                        <rect x="29.8" y="28" className="cst0" width="8.9" height="3.4" />
                                        <rect x="12.5" y="38.4" transform="matrix(-0.4212 0.9069 -0.9069 -0.4212 63.2795 39.8947)" className="cst0" width="12.8" height="3.4" />
                                        <g>
                                            <path className="cst1" d="M24.5,36.1c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2S28.4,36.1,24.5,36.1 M24.5,25.2
                                    c-2.1,0-3.7,1.7-3.7,3.7c0,2.1,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7C28.2,26.9,26.5,25.2,24.5,25.2"/>
                                            <path className="cst1" d="M9.4,18.8C4.2,18.8,0,14.6,0,9.4S4.2,0,9.4,0c5.2,0,9.4,4.2,9.4,9.4S14.5,18.8,9.4,18.8 M9.4,3.4
                                    c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S12.7,3.4,9.4,3.4"/>
                                            <path className="cst1" d="M15.1,55.1c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4s5.4,2.4,5.4,5.4C20.5,52.7,18.1,55.1,15.1,55.1
                                    M15.1,47.7c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C17.1,48.5,16.2,47.7,15.1,47.7"/>
                                            <path className="cst1" d="M47.9,40.7c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9S54,40.7,47.9,40.7 M47.9,22.2
                                    c-4.2,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5S52.1,22.2,47.9,22.2"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className="text-Content">
                                    <div className="text-Title">
                                        100% <br /> decentralized
                                    </div>
                                    <p>DAO approach with a closed system lacking any single point of failure privilege</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}